import React, { FC } from 'react';
import { CalendarView } from '../components';

export const CalendarPage: FC = () => {
  return <CalendarView />;
};
